// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vP4O","controls":"styles_controls__2nhOQ","charLimit":"styles_charLimit__ExeUg","input":"styles_input__1AA38","send":"styles_send__xmayq"};